/**
 * EntityTypePill — pill showing attraction type (Attraction, Show, etc.).
 */
interface EntityTypePillProps {
  entityType: string;
}

export function EntityTypePill({ entityType }: EntityTypePillProps): React.ReactElement {
  return (
    <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300">
      {entityType}
    </span>
  );
}
